import {configureStore} from "@reduxjs/toolkit"
import { AuthApi } from "./Redux/Api/AuthApi"
import AuthReducer from "./Redux/Slice/AuthSlice"
import ContentReducer from "./Redux/Slice/ContentSlice"
import { setupListeners } from "@reduxjs/toolkit/query"
import { ContentApi } from "./Redux/Api/ContentApi"

export const store = configureStore({
    reducer:{
        [AuthApi.reducerPath]:AuthApi.reducer ,
        [ContentApi.reducerPath]:ContentApi.reducer,
        Auth:AuthReducer,
        Content:ContentReducer 
    },
    middleware:getDefaultMiddleware =>getDefaultMiddleware().concat(AuthApi.middleware,ContentApi.middleware),
    devTools:true
})

setupListeners(store.dispatch)